<template>
  <div class="stash-accordion-group flex flex-col gap-y-2" data-test="stash-accordion-group">
    <slot></slot>
  </div>
</template>
